import { createReducer, on } from '@ngrx/store';
import * as pageActions from '../actions/faq.action';
import { ToEntities } from '@teamfoster/sdk/array-utility';
import { FaqItem } from '../../models';

export interface FaqState {
  entities: { [id: string]: FaqItem };
  loaded: boolean;
  loading: boolean;
  error?: any;
}

export const initialState: FaqState = {
  entities: {},
  loaded: false,
  loading: false,
};

export const FaqReducer = createReducer(
  initialState,
  on(pageActions.LoadFaq, (state: FaqState) => {
    return {
      ...state,
      loading: true,
    };
  }),
  on(pageActions.LoadFaqSuccess, (state: FaqState, { faq }) => {
    const entities = ToEntities(faq, 'id', state.entities);
    return {
      ...state,
      entities,
      loading: false,
      loaded: true,
    };
  }),
  on(pageActions.LoadFaqFail, (state: FaqState, { error }) => {
    return {
      ...state,
      loading: false,
      loaded: false,
      error,
    };
  }),
  on(pageActions.ClearFaq, (state: FaqState) => {
    return {
      ...initialState,
    };
  })
);

export const getFaqEntities = (state: FaqState) => state.entities;
export const getFaqLoading = (state: FaqState) => state.loading;
export const getFaqLoaded = (state: FaqState) => state.loaded;
